<mat-slide-toggle
  *ngIf="control"
  appearance="outline"
  [formControl]="control"
  [required]="required"
  [ngClass]="{ disabled: control.disabled }"
  (change)="onChange($event)"
>
  {{ label }}
</mat-slide-toggle>
